import React from "react";
import { Warning, Info } from "@phosphor-icons/react";
import { LOW_CONFIDENCE_FIELD_LABELS } from "./types";

interface ExtractionReviewBannerProps {
  lowConfidenceFields: string[];
  warnings: string[];
}

/**
 * Shows which fields Ella could not read with confidence (left blank for the
 * user to fill) plus any non-fatal mapping warnings. Rendered only after an
 * extraction that produced something to flag.
 */
const ExtractionReviewBanner: React.FC<ExtractionReviewBannerProps> = ({
  lowConfidenceFields,
  warnings,
}) => {
  const hasFields = lowConfidenceFields && lowConfidenceFields.length > 0;
  const hasWarnings = warnings && warnings.length > 0;
  if (!hasFields && !hasWarnings) return null;

  const fieldLabels = Array.from(
    new Set(lowConfidenceFields.map((f) => LOW_CONFIDENCE_FIELD_LABELS[f] || f)),
  );

  return (
    <div className="mb-4 rounded-lg border border-amber-300 bg-amber-50 p-3">
      {hasFields && (
        <div className="flex items-start gap-2">
          <Warning size={18} className="mt-0.5 shrink-0 text-amber-700" weight="fill" />
          <div className="text-sm text-amber-900">
            <span className="font-medium">Controleer deze velden:</span>{" "}
            {fieldLabels.join(", ")}.
            <span className="block text-xs text-amber-800">
              Ella kon deze niet met zekerheid uitlezen — vul ze handmatig aan.
            </span>
          </div>
        </div>
      )}
      {hasWarnings && (
        <ul className="mt-2 space-y-1">
          {warnings.map((w, i) => (
            <li key={i} className="flex items-start gap-2 text-xs text-amber-800">
              <Info size={14} className="mt-0.5 shrink-0" />
              <span>{w}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ExtractionReviewBanner;
